import { queryKeys } from 'queries/queryKeys'

export const useFileKeys = (where: 'docs' | 'templates') => {
  const many = where === 'templates' ? queryKeys.TEMPLATES : queryKeys.DOCUMENTS
  const single = where === 'templates' ? queryKeys.TEMPLATE : queryKeys.DOCUMENT
  return [many, single]
}
